import React, {useEffect, useState} from 'react'

import CalendarIcon from '../../../images/icons/new-dashboard/calendar-icon.svg'
import EditIcon from '../../../images/icons/new-dashboard/edit-icon.svg'
import PassedIcon from '../../../images/icons/new-dashboard/complete-icon.svg'
import {
  CompletedText,
  DateBox,
  DateText,
  StyledDatepickerIcon,
  StyledIcon,
  StyledInput,
} from './styles'
import {Popover} from '@mui/material'
import DateSelector from '../../../components/DateRangePicker'
import {Divisions, getDivisionDetails} from '../../../constants/divisions'
import {Attempt} from '../../../redux/reportExamStatus'

type Props = {
  division: Divisions
  dateFilter: string
  onChangeDateFilter: (
    value: string,
    courseId?: string,
    attemptId?: string,
  ) => void
  reportStatus?: Attempt
  courseId?: string
}

const View = ({
  division,
  dateFilter,
  onChangeDateFilter,
  reportStatus,
  courseId,
}: Props) => {
  const [anchorEl, setAnchorEl] = useState<HTMLDivElement | null>(null)
  const [isEditMode, setIsEditMode] = useState<boolean>(false)

  const handleOpenDatePicker = (event: React.MouseEvent<HTMLDivElement>) => {
    setAnchorEl(event.currentTarget)
  }

  const handleCloseDatePicker = () => {
    setAnchorEl(null)
  }

  const open = Boolean(anchorEl)
  const id = open ? 'datepicker-popover' : undefined

  const handleChangeDatePicker = (date: string) => {
    const attemptIdToUse =
      reportStatus?.passed === null ? reportStatus.attemptId : undefined
    onChangeDateFilter(date, courseId, attemptIdToUse)
    handleCloseDatePicker()
  }

  const divisionDetails = getDivisionDetails(division)

  const isDivisionComplete = !!reportStatus?.passed
  const isExamStatusPending = reportStatus?.passed === null

  const getDate = () => {
    if (!reportStatus?.examDate) return ''
    const date = new Date(reportStatus.examDate)
    date.setHours(date.getHours() + 12)
    return date.toLocaleDateString('en-US')
  }

  useEffect(() => {
    setIsEditMode(false)
  }, [reportStatus])

  return (
    <DateBox>
      {division && (
        <StyledIcon
          $isDivisionComplete={isDivisionComplete}
          src={divisionDetails?.icon}
          alt="division"
        />
      )}
      {isDivisionComplete ? (
        <>
          <CompletedText>
            <img src={PassedIcon} alt={`${division} Passed`} /> Exam passed
          </CompletedText>
          <div style={{width: '16px'}} />
        </>
      ) : (
        <>
          {isExamStatusPending && reportStatus?.examDate && !isEditMode ? (
            <DateText>scheduled {getDate()}</DateText>
          ) : (
            <StyledInput
              placeholder="mm/dd/yyyy"
              readOnly
              value={dateFilter}
              onClick={handleOpenDatePicker}
            />
          )}
          <StyledDatepickerIcon
            src={
              reportStatus && isExamStatusPending && !isEditMode
                ? EditIcon
                : CalendarIcon
            }
            alt="select a date"
            onClick={
              reportStatus && isExamStatusPending && !isEditMode
                ? () => setIsEditMode(true)
                : handleOpenDatePicker
            }
          />
          <Popover
            id={id}
            open={open}
            anchorEl={anchorEl}
            onClose={handleCloseDatePicker}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'left',
            }}
          >
            <DateSelector
              isDatePicker={true}
              onChangeDateFilter={handleChangeDatePicker}
            />
          </Popover>
        </>
      )}
    </DateBox>
  )
}

export default View
